import { ParallaxLayer } from "../ParallaxScene";
import { FrostLayer } from "../FrostLayer";

export const ConnectionCard = ({ person, onCta }) => (
  <article className="spc group relative aspect-[2/3] w-full overflow-hidden" style={{ "--tint": person.tint, borderRadius: 34 }} data-testid={`connection-card-${person.id}`}>
    <div className="absolute inset-[-6%]">
      <ParallaxLayer y={[-26, 26]} className="h-full w-full">
        <img src={person.image} alt={person.alt} loading="lazy" decoding="async" width="800" height="1192" className="spc-img h-full w-full object-cover" />
      </ParallaxLayer>
    </div>
    <FrostLayer src={person.image} height="64%" />
    <div className="spc-body absolute inset-x-0 bottom-0 z-[2] flex flex-col items-center text-center">
      <span className="spc-pill" data-testid={`connection-card-${person.id}-stat`}>{person.stat}</span>
      <h3 className="conn-name">{person.name}</h3>
      <p className="spc-sub">{person.bio}</p>
      <ul className="mb-2 flex flex-wrap justify-center gap-1.5" aria-label="Shared interests">
        {person.interests.map((i) => <li key={i} className="interest-chip">{i}</li>)}
      </ul>
      <p className="conn-why">
        <span className="font-semibold text-white">Why you might connect: </span>
        {person.why}
      </p>
      <button type="button" onClick={onCta} data-testid={`connection-card-${person.id}-cta`} className={`spc-cta spc-cta--${person.ctaStyle}`}>
        {person.cta}
      </button>
    </div>
  </article>
);
